import { useEffect, useState } from 'react';
import { ChannelIconData, fetchChannel } from '@/core/services/ChannelsService';

export function useChannelIcon(platform: string, preloaded?: ChannelIconData): ChannelIconData | undefined {
  const [fetched, setFetched] = useState<ChannelIconData | undefined>(undefined);

  useEffect(() => {
    if (preloaded || !platform) return;

    let cancelled = false;

    fetchChannel(platform)
      .then((data) => {
        if (!cancelled) setFetched(data);
      })
      .catch((err) => {
        console.error(`Failed to load channel icon for "${platform}":`, err);
      });

    return () => {
      cancelled = true;
    };
  }, [platform, preloaded]);

  return preloaded ?? fetched;
}